export default __webpack_public_path__ + "static/media/cross.4fb48b17.svg";